import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { focusRing } from '@clds/style-utils';
import { colorPickerSizeVariant, colorPickerTheme } from '../theme';

export const ColorItem = styled.div.attrs({ 'data-test': 'color-item' })`
  cursor: pointer;
  list-style: none;
  border-radius: ${globalTheme.radius.unstable_new.md};
  border: solid 1px ${colorPickerTheme.item.borderColor};
  background: ${({ value }) => value};
  width: ${colorPickerSizeVariant((branch) => branch.width)};
  height: ${colorPickerSizeVariant((branch) => branch.height)};
  &:focus {
    ${focusRing()}
    border-color: ${globalTheme.palette.primary};
  }
`;
